<template>
    <div class="loading-container">
        <div class="dot-pulse" :aria-label="t('loading')"></div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n({
    messages: {
        fr: {
            loading: "En cours de chargement...",
        },
        en: {
            loading: 'Loading...',
        },
    },
});
</script>

<style lang="scss" scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 200px;
}

@mixin dot(
  $width: $dot-width,
  $height: $dot-height,
  $radius: $dot-radius,
  $bg-color: $dot-bg-color,
  $color: $dot-color
) {
  width: $width;
  height: $height;
  border-radius: $radius;
  background-color: $bg-color;
  color: $color;
}

$dot-width: 10px;
$dot-height: 10px;
$dot-radius: $dot-width * .5;

$dot-color: $color-blue-60;
$dot-bg-color: $dot-color;
$dot-before-color: $dot-color;
$dot-after-color: $dot-color;

$dot-spacing: $dot-width + $dot-width * .5;
$left-pos: -9999px;
$x1: - $left-pos - $dot-spacing;
$x2: - $left-pos;
$x3: - $left-pos + $dot-spacing;

.dot-pulse {
    @include dot;
    position: relative;
    left: $left-pos;
    box-shadow: $x2 0 0 -5px;
    animation: dot-pulse 1.5s infinite linear;
    animation-delay: .25s;
    &::before,
    &::after {
        @include dot;
        content: '';
        display: inline-block;
        position: absolute;
        top: 0;
    }
    &::before {
        box-shadow: $x1 0 0 -5px;
        animation: dot-pulse-before 1.5s infinite linear;
        animation-delay: 0s;
    }
    &::after {
        box-shadow: $x3 0 0 -5px;
        animation: dot-pulse-after 1.5s infinite linear;
        animation-delay: .5s;
    }
}
@keyframes dot-pulse-before {
    0% {
        box-shadow: $x1 0 0 -5px;
    }
    30% {
        box-shadow: $x1 0 0 2px;
    }
    60%,
    100% {
        box-shadow: $x1 0 0 -5px;
    }
}
@keyframes dot-pulse {
    0% {
        box-shadow: $x2 0 0 -5px;
    }
    30% {
        box-shadow: $x2 0 0 2px;
    }
    60%,
    100% {
        box-shadow: $x2 0 0 -5px;
    }
}
@keyframes dot-pulse-after {
    0% {
        box-shadow: $x3 0 0 -5px;
    }
    30% {
        box-shadow: $x3 0 0 2px;
    }
    60%,
    100% {
        box-shadow: $x3 0 0 -5px;
    }
}
</style>
